<template>
  <div id="muck-view">
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card ref="filterCard" :title="$t('Filters')" class="muck-list-filters mb-8" title-color="black" collapse-action>
          <div class="vx-row">
            <div class="vx-col w-full md:w-1/5 " >
              <form-label>{{$t('GradeControl.Location.Type')}}</form-label>
              <v-select
                label="name"
                :options="locationTypes"
                :reduce="type => type.id"
                v-model="selectedLocationTypeId"
                class="w-full"
                name="locationType"
              />
            </div>
            <div class="vx-col w-full md:w-1/5 " >
              <form-label>{{$t('GradeControl.Location.Name')}}</form-label>
              <v-select
                label="code"
                :options="locations"
                :reduce="location => location.locationId"
                v-model="selectedLocationId"
                class="w-full"
                name="locationId"
              />
            </div>
            <div class="vx-col w-full md:w-1/4 " >
              <form-label>{{$t('GradeControl.Forecast.ForecastList')}}</form-label>
              <v-select
                label="startDate"
                :options="forecastList"
                :reduce="f => f.locationForecastId"
                v-model="selectedLocationForecastId"
                class="w-full"
                name="forecastList">
                <template slot="selected-option"  slot-scope="{ startDate, endDate }">
                  {{ startDate | toDate }} - {{ endDate | toDate }}
                </template>
                <template slot="option" slot-scope="{ startDate, endDate }">
                  {{ startDate | toDate }} - {{ endDate | toDate }}
                </template>
              </v-select>
            </div>
            <div class="vx-col w-full md:w-1/4 " >
              <form-label>{{$t('GradeCalculation.Name')}}</form-label>
              <v-select
                label="name"
                :options="gradeCalculation"
                :reduce="calc => calc.id"
                v-model="selectedCalculation"
                class="w-full"
                name="calculationId"
              />
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-1/2 w-full mb-base" >
        <vx-card v-show="selectedLocationForecastId" ref="gradeTonnageAnalyticsCard" :title="$t('GradeControl.ProductionSummary.GradePerPeriod')" class="mb-8" title-color="black" collapse-action refresh-content-action @refresh="getGradeTonnageAnalytics">
          <GradeTonnageAnalytics
            ref="gradeTonnage">
          </GradeTonnageAnalytics>
        </vx-card>
      </div>
      <div class="vx-col md:w-1/2 w-full mb-base" >
        <vx-card v-show="selectedLocationForecastId" ref="forecastStatsCard" :title="$t('GradeControl.Forecast.Statistics')" class="mb-8" title-color="black"   collapse-action refresh-content-action @refresh="getForecastStatistics" >
          <ForecastVsActualAnalytics
            ref="forecastActual" />
        </vx-card>
      </div>
    </div>
    <div class="vx-row">
      <vx-card v-show="selectedLocationForecastId" ref="muckListCard" :title="$t('GradeControl.Muck.MuckList')"  class="list-filters mb-8" title-color="black" refresh-content-action @refresh="getMuckEntries" >
        <MuckListGrid
          ref="muckGrid"
          @onMuckUpdated="muckUpdated"
          @onSelectMuck="selectMuck"
          :gradeCalculationType="selectedCalculation"
        ></MuckListGrid>
      </vx-card>
    </div>
    <div class="vx-row">
      <vx-card v-show="selectedLocationForecastId" ref="haulingListCard" :title="$t('GradeControl.Muck.HaulingList')"  class="list-filters mb-8" title-color="black" collapse-action refresh-content-action @refresh="getHaulingEntries" >
        <HaulingListGrid
          ref="haulingGrid"
          @onSelectMuck="selectMuck"
          :gradeCalculationType="selectedCalculation"
        ></HaulingListGrid>
      </vx-card>
    </div>
    <div class="vx-row">
      <vx-card v-show="selectedLocationForecastId && selectedMuck" ref="sampleListCard" :title="$t('GradeControl.Sample.SampleList')"  class="list-filters mb-8" title-color="black" remove-card-action >
        <SampleListGrid
          :selectedMuck="selectedMuck"
          @onUpdateSample="updateSample"
          ref="sampleGrid"
        ></SampleListGrid>
      </vx-card>
    </div>
</div>
</template>
<script>
import MuckListGrid from "./components/MuckListGrid";
import HaulingListGrid from "./components/HaulingListGrid";
import SampleListGrid from "./components/SampleListGrid";
import GradeTonnageAnalytics from "./components/GradeTonnageAnalytics"
import ForecastVsActualAnalytics from "./components/ForecastVsActualAnalytics"

import vSelect from 'vue-select';


import { FormLabel } from "../../../shared/components";
import moduleGradeControl from "@/store/geo/gradecontrol/moduleGradeControl.js";
import LocationTypeEnum from "./../LocationTypeEnum.js"
import GradeCalculationTypeEnum from "./../GradeCalculationTypeEnum.js"

export default {
  components: {
    vSelect,
    MuckListGrid,
    HaulingListGrid,
    SampleListGrid,
    ForecastVsActualAnalytics,
    FormLabel,
    GradeTonnageAnalytics
  },
  data() {
    return {
      selectedLocationTypeId: LocationTypeEnum.Production,
      selectedLocationId: null,
      selectedProjectId: null,
      selectedLocationForecastId: null,
      selectedMuck: null,
      selectedCalculation: GradeCalculationTypeEnum.SampleOrForecastCapped,
      sidebarData: {},
      locationTypes: LocationTypeEnum.definition,
      gradeCalculation: []
    };
  },
  computed: {
    locations() {
      return this.$store.state.gradeControl.locations.filter(l => l.type === this.selectedLocationTypeId).sort((a, b) => { return (a.code > b.code) ? 1 : -1 });
    },
    forecastList() {
      return this.$store.state.gradeControl.forecasts;
    },
    muckTypes() {
      return this.$store.state.gradeControl.muckTypes;
    },
    equipments() {
      return this.$store.state.gradeControl.equipments;
    },
    employees() {
      return this.$store.state.gradeControl.employees;
    },
    materialSubTypes() {
      return this.$store.state.gradeControl.materialSubTypes;
    },
    selectedDateTime() {
      const selectedForecast = this.$store.state.gradeControl.forecasts.find(f => f.locationForecastId === this.selectedLocationForecastId);

      if (selectedForecast)
        return new Date(selectedForecast.startDate);

      return null;
    }
  },
  watch: {
    selectedLocationId(val) {
      if (!val) return;

      this.getForecastEntries();
    },
    selectedLocationForecastId(val) {
      if (!val) return

      this.$refs.muckListCard.refreshcard();
      this.$refs.haulingListCard.refreshcard();
      this.$refs.forecastStatsCard.refreshcard();
   
    },
    selectedCalculation() {
      this.$refs.muckListCard.refreshcard();
      this.$refs.haulingListCard.refreshcard();
      this.$refs.forecastStatsCard.refreshcard();
    }
  },
  mounted() {
    this.$store.dispatch("gradeControl/clearMuckListItems");
    this.$store.dispatch("gradeControl/clearHaulingListItems");
  },
  created() {
    if (!moduleGradeControl.isRegistered) {
      this.$store.registerModule("gradeControl", moduleGradeControl);
      moduleGradeControl.isRegistered = true;
    }

    this.gradeCalculation = [
      { id:GradeCalculationTypeEnum.SampleOnly, name:this.$t("GradeCalculation." + GradeCalculationTypeEnum.SampleOnly) },
      { id:GradeCalculationTypeEnum.SampleOnlyCapped, name:this.$t("GradeCalculation." + GradeCalculationTypeEnum.SampleOnlyCapped) },
      { id:GradeCalculationTypeEnum.SampleOrForecast, name:this.$t("GradeCalculation." + GradeCalculationTypeEnum.SampleOrForecast) },
      { id:GradeCalculationTypeEnum.SampleOrForecastCapped, name:this.$t("GradeCalculation." + GradeCalculationTypeEnum.SampleOrForecastCapped) }
    ];

    this.selectedProjectId = Number(this.$store.state.projectId);
    this.$vs.loading();
    Promise.all([
      this.$store.dispatch("gradeControl/fetchLocationListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchEquipmentListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchEmployeeListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchMuckTypeListItems", this.selectedProjectId),
      this.$store.dispatch("gradeControl/fetchMaterialSubTypeListItems", this.selectedProjectId)
    ]).finally(() => {
      this.$vs.loading.close();
    })
  },
  methods: {
    locationForecastSelected(locationForecast) {
      this.selectedLocationForecastId = locationForecast.locationForecastId;
    },
    getForecastEntries() {
      if (this.selectedLocationId) {
        return this.$store.dispatch("gradeControl/fetchLocationForecasts", this.selectedLocationId).then(() => {
          //Automatically select last date
          if (this.$store.state.gradeControl.forecasts.length > 0) {
            this.selectedLocationForecastId = this.$store.state.gradeControl.forecasts[this.$store.state.gradeControl.forecasts.length - 1].locationForecastId;
          }
        });
      }
    },
    getGradeTonnageAnalytics() {
      if (this.selectedLocationForecastId) {
        this.$refs.gradeTonnage.defineDiagramSettings(this.selectedCalculation);
      }
      
      this.$refs.gradeTonnageAnalyticsCard.removeRefreshAnimation()
    },
    getMuckEntries() {
      if (this.selectedLocationForecastId) {
        this.$refs.muckGrid.getMuckEntries(this.selectedLocationForecastId).then(() => { 
          this.$refs.muckListCard.removeRefreshAnimation();
          this.$refs.gradeTonnageAnalyticsCard.refreshcard();
        });
      }
      else {
        this.$refs.muckListCard.removeRefreshAnimation();
      }
    },
    getHaulingEntries() {
      if (this.selectedLocationForecastId) {
        this.$refs.haulingGrid.getHaulingEntries(this.selectedLocationForecastId).then(() => { 
          this.$refs.haulingListCard.removeRefreshAnimation();
        });
      }
      else {
        this.$refs.haulingListCard.removeRefreshAnimation();
      }
    },
    getForecastStatistics() {
      if (this.selectedLocationForecastId) {
        this.$refs.forecastActual.defineForecastAndActual(this.selectedLocationForecastId, this.selectedCalculation).then(() => { 
          this.$refs.forecastStatsCard.removeRefreshAnimation();
        });
      }
      else {
        this.$refs.forecastStatsCard.removeRefreshAnimation()
      }
    },
    updateSample() {
      this.$refs.muckGrid.updateMuckEntry(this.selectedMuck);
      this.$refs.haulingGrid.updateHaulingEntry(this.selectedMuck);
      this.$refs.forecastStatsCard.refreshcard();
      this.$refs.gradeTonnageAnalyticsCard.refreshcard();
    },
    
    muckUpdated(muck) {
      this.$vs.notify({
        title: this.$t("Success"),
        text: this.$t("SaveSuccess"),
        color: "success"
      });

      const date1 = new Date(this.selectedDateTime);
      const date2 = new Date(muck.extractionDate)

      if (date1.Date === date2.Date) {
        this.$refs.muckGrid.updateGrid(muck);
        this.$refs.forecastStatsCard.refreshcard();
        this.$refs.gradeTonnageAnalyticsCard.refreshcard();
      }
    },
    selectMuck(data) {
      this.$refs.sampleListCard.redisplayCard();
      this.selectedMuck = data;
    }
  }
};
</script>
<style lang="scss">
#muck-view {
  .list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}

</style>
